import { slice } from 'lodash';
import { environment } from '../../../../../../environments/environment';
declare var Papa: any;
declare var angular: any;

angular
  .module('ManagerControllers')

  .component('cfUsersList', {
    bindings: {
      role: '<',
      type: '<',
    },
    templateUrl: '/ng1/www/modules/manager/students/html/users_list.html',
    controller: [
      '$mdDialog',
      'api',
      '$mdToast',
      '$translate',
      function ($mdDialog, api, $mdToast, $translate) {
        this.$onInit = () => {
          this.getProfiles();

          if (this.role === 'manager') {
            if (this.type === 'teacher') {
              this.title = 'navbar.trainers';
              this.description = 'users_list.manager.teacher_description';
            }

            if (this.type === 'student') {
              this.title = 'navbar.learners';
              this.description = 'users_list.manager.student_description';
            }
          }

          if (this.role === 'teacher') {
            this.title = 'navbar.trainers';
            this.description = 'users_list.teacher.description';
          }
        };

        this.dispatchAction = (event) => {
          if (event.type === 'download_pdf') {
            console.log('event', event);
            this.downloadStudentByProfileIdInfos(event.data.studentId);
          } else if (event.type === 'update') {
            this.getProfiles();
          } else if (event.type === 'resend_login') {
            this.resetUserPassword(event.data.email);
          } else if (event.type === 'delete_account') {
            this.deleteStudent(event.data.student, event.data.index);
          } else if (event.type === 'show_student') {
            this.showStudentProfile(event.data.student);
          } else if (event.type === 'extend') {
            this.extendStudentProfile(event.data.student);
          }
        };

        this.showStudentProfile = (student) => {
          $mdDialog.show({
            locals: {
              student: student,
            },
            controller: [
              '$scope',
              '$mdDialog',
              'api',
              'EXAM',
              'student',
              function DialogController($scope, $mdDialog, api, EXAM, student) {
                console.log('student', student);
                $scope.currentStudent = {
                  ...student,
                  profile: {
                    objective: student.objective,
                  },
                };

                api
                  .getStats(student.user.id, student.level)
                  .then(function (data) {
                    $scope.stats = data;
                    $scope.mainData = { me: $scope.currentStudent, exam: EXAM };
                  });

                $scope.close = function () {
                  $mdDialog.hide();
                };
              },
            ],
            templateUrl:
              '/ng1/www/modules/teacher/students/html/student-detail-dialog.html',
            clickOutsideToClose: true,
            preserveScope: true,
            parent: angular.element(document.body),
          });
        };

        this.getProfiles = () => {
          api.getInstitutionProfiles(this.type, this.role).then((data) => {
            this.data = data;
            this.credits = data.parent_institution_id
              ? data.parent_institution.credits
              : data.credits;

            this.translationsDatas = {
              credits: this.credits,
            };

            console.log('data', data);
          });
        };

        this.resetUserPassword = (email) => {
          var confirm = $mdDialog
            .confirm({
              preserveScope: true,
              parent: angular.element(document.body),
            })
            .title(
              'Êtes vous sur de vouloir renvoyer les identifiants à cet utilisateur ?'
            )
            .textContent(
              "L'utilisateur " +
                email +
                ' recevra un email avec ces nouveaux identifiants.'
            )
            .ariaLabel('Nouveaux identifiants')
            .ok('Confirmer')
            .cancel('Annuler');

          $mdDialog.show(confirm).then(() => {
            api
              .resetPasswordFromManagerAction(email)
              .success((res) => {
                $mdDialog.show(
                  $mdDialog
                    .alert({
                      preserveScope: true,
                      parent: angular.element(document.body),
                    })
                    .clickOutsideToClose(true)
                    .title(
                      'Voici les nouveaux identifiants que vous pouvez également envoyer par email (1 seul affichage)'
                    )
                    .textContent(
                      'Email : ' + email + ', mot de passe : ' + res.password
                    )
                    .ariaLabel('Nouveaux identifiants')
                    .ok('Fermer')
                );

                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      'Un email a été envoyé avec les nouveaux identifiants'
                    )
                    .position('bottom right')
                    .hideDelay(3000)
                );
              })
              .error((data) => {
                console.log(data);
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent('Une erreur est survenue')
                    .position('bottom right')
                    .hideDelay(2000)
                );
              });
          });
        };

        this.extendStudentProfile = (student, index) => {
          console.log(student, index);

          let days = (student.level as string).includes('JR')
            ? '9 mois'
            : '3 mois';

          var confirm = $mdDialog
            .confirm({
              preserveScope: true,
              parent: angular.element(document.body),
            })
            .title(
              `Êtes-vous sur de vouloir étendre la durée du compte de ${days} (1 licence) ?`
            )
            .textContent(student.user.email)
            .ariaLabel('Extension de compte')
            .ok('Confirmer')
            .clickOutsideToClose(true)
            .cancel('Annuler');

          $mdDialog.show(confirm).then(() => {
            api
              .extendUser(student.user.email)
              .success(() => {
                this.getProfiles();
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent('Le compte a bien été étendu')
                    .position('bottom right')
                    .hideDelay(3000)
                );
              })
              .error((data) => {
                console.log(data);
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent('Une erreur est survenue')
                    .position('bottom right')
                    .hideDelay(2000)
                );
              });
          });
        };

        this.deleteStudent = (student, index) => {
          console.log(student, index);

          var confirm = $mdDialog
            .confirm({
              preserveScope: true,
              parent: angular.element(document.body),
            })
            .title('Êtes vous sur de vouloir supprimer le compte ?')
            .textContent(student.user.email)
            .ariaLabel('Suppression de compte')
            .ok('Confirmer')
            .clickOutsideToClose(true)
            .cancel('Annuler');

          $mdDialog.show(confirm).then(() => {
            api
              .institutionDeleteUser(student.user.email)
              .success(() => {
                this.getProfiles();
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent('Le compte a bien été supprimé')
                    .position('bottom right')
                    .hideDelay(3000)
                );
              })
              .error((data) => {
                console.log(data);
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent('Une erreur est survenue')
                    .position('bottom right')
                    .hideDelay(2000)
                );
              });
          });
        };

        this.downloadStudentsInfos = ($event) => {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent(
                "Document en cours de préparation. Merci de patienter sur la page. L'attente peut durer jusqu'à 2 minutes."
              )
              .position('bottom right')
              .hideDelay(10000)
          );

          api.getInstitutionStudentsInfoInCSV(this.role).then((res) => {
            var BOM = '\uFEFF';

            var encodedUri = encodeURI(
              'data:text/csv;charset=utf-8,' + BOM + res
            );
            var link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'students.csv');
            document.body.appendChild(link);

            link.click(); // This will download the data file named "my_data.csv".
          });
        };

        this.downloadStudentByProfileIdInfos = function (studentProfileId) {
          api.getInstitutionStudentInfoByProfileIdInCSV(studentProfileId);
        };

        var self = this;
        this.createStudent = (ev) => {
          $mdDialog
            .show({
              targetEvent: ev,
              locals: {
                credits: this.data.parent_institution_id
                  ? this.data.parent_institution.credits
                  : this.data.credits,
                theme: 'default',
              },
              clickOutsideToClose: true,
              preserveScope: true,
              parent: angular.element(document.body),
              templateUrl:
                '/ng1/www/modules/manager/students/html/dialog_create_student.html',

              controller: [
                '$scope',
                '$mdDialog',
                '$mdToast',
                'credits',
                'theme',
                function DialogController(
                  $scope,
                  $mdDialog,
                  $mdToast,
                  credits,
                  theme
                ) {
                  $scope.type = 'password';
                  $scope.loginTypes = [
                    {
                      text: 'Email et mot de passe',
                      value: 'password',
                    },
                    {
                      text: 'SSO Microsoft',
                      value: 'microsoft',
                    },
                    /*
              {
                text: "SSO Google",
                value: "google"
              },
              */
                  ];

                  $scope.loading = false;

                  $scope.user = {};
                  $scope.bulk = {};

                  $scope.levels = (environment as any)?.levels?.options;
                  if ($scope.levels?.length) {
                    $scope.user.level = (environment as any).levels?.default;
                    $scope.bulk.level = (environment as any).levels?.default;
                  }

                  $scope.theme = theme;

                  $scope.credits = credits;

                  $scope.close = function () {
                    if ($scope.students.length > 0) {
                      $mdDialog.hide($scope.students);
                    } else {
                      $mdDialog.cancel();
                    }
                  };

                  $scope.confirm = function () {
                    $scope.loading = true;

                    api
                      .institutionCreateUser(
                        $scope.user.first_name,
                        $scope.user.last_name,
                        $scope.user.email,
                        'student',
                        $scope.type,
                        $scope.user.level
                      )
                      .success(function (student) {
                        $scope.loading = false;

                        $mdDialog.hide([student]);
                      })
                      .error(function (data) {
                        $scope.loading = false;

                        $mdToast.show(
                          $mdToast
                            .simple()
                            .textContent(data.description)
                            .position('bottom right')
                        );
                        $mdDialog.cancel();
                      });
                  };

                  $scope.importPhase = 1;
                  $scope.setImportPhase = function (x) {
                    $scope.importPhase = x;
                  };
                  $scope.missing = [];
                  $scope.uploadFile = function () {
                    $scope.importPhase = 2;
                    var file = (document.getElementById('import-file') as any)
                      .files[0];

                    Papa.parse(file, {
                      header: true,
                      complete: function (results, file) {
                        if (results.meta.fields[0] === 'Prénom') {
                          importAllStudents(results, file);
                        } else {
                          Papa.parse(file, {
                            encoding: 'ISO-8859-1',
                            header: true,
                            complete: importAllStudents,
                          });
                        }
                      },
                    });

                    function importAllStudents(results, file) {
                      $scope.$apply(function () {
                        var length = results.data.length;
                        results.errors.forEach(function (error) {
                          delete results.data[error.row];
                        });

                        var missing = [];
                        results.data.forEach(function (x, row) {
                          if (!!x) {
                            if (!x['Prénom']) {
                              missing.push('Prénom');
                              delete results.data[row];
                            }
                            if (!x['Nom']) {
                              missing.push('Nom');
                              delete results.data[row];
                            }
                            if (!x['Email']) {
                              missing.push('Email');
                              delete results.data[row];
                            }
                          }
                        });
                        results.data = results.data.filter(function (x, index) {
                          return !!x;
                        });
                        // remove duplicate
                        $scope.missing = missing
                          .sort()
                          .filter(function (x, i, a) {
                            !i || x != a[i - 1];
                          });
                        if (missing.length > 0) {
                          results.data = [];
                        }

                        results.errors = results.errors.filter(function (x) {
                          return (
                            x.row !== length - 1 || x.code !== 'TooFewFields'
                          );
                        });

                        $scope.results = results;
                      });
                    }
                  };

                  $scope.importing = false;
                  $scope.imported = 0;
                  $scope.students = [];
                  $scope.errors = [];
                  $scope.importStudent = () => {
                    $scope.importing = true;
                    $scope.results.data.forEach((row, index) => {
                      setTimeout(function () {
                        api
                          .institutionCreateUser(
                            row['Prénom'].trim(),
                            row['Nom'].trim(),
                            row['Email'].trim(),
                            'student',
                            $scope.type,
                            $scope.bulk.level
                          )
                          .success(function (student) {
                            $scope.imported++;
                            $scope.students.push(student);
                          })
                          .error(function (data) {
                            $scope.imported++;
                            data.row = row;
                            $scope.errors.push(data);
                          });
                      }, index * 800);
                    });
                  };
                },
              ],
            })
            .then((students) => {
              if (students) {
                self.getProfiles();
              }
            });
        };

        this.createTeacher = (ev) => {
          $mdDialog
            .show({
              targetEvent: ev,
              clickOutsideToClose: true,
              preserveScope: true,
              parent: angular.element(document.body),
              templateUrl:
                '/ng1/www/modules/manager/teachers/html/dialog_create_teacher.html',
              locals: {
                theme: 'default',
              },
              controller: [
                '$scope',
                '$mdDialog',
                'theme',
                function DialogController($scope, $mdDialog, theme) {
                  $scope.type = 'password';
                  $scope.loginTypes = [
                    {
                      text: 'Email et mot de passe',
                      value: 'password',
                    },
                    {
                      text: 'SSO Microsoft',
                      value: 'microsoft',
                    },
                    /*
              {
                text: "SSO Google",
                value: "google"
              },
              */
                  ];

                  $scope.theme = theme;

                  $scope.close = function () {
                    $mdDialog.cancel();
                  };

                  $scope.confirm = function () {
                    console.log($scope.user);
                    api
                      .institutionCreateUser(
                        $scope.user.first_name,
                        $scope.user.last_name,
                        $scope.user.email,
                        'teacher',
                        $scope.type,
                        (environment as any).levels?.default
                          ? (environment as any).levels?.default
                          : null
                      )
                      .success(function (student) {
                        $mdDialog.hide(student);
                      })
                      .error(function (data) {
                        $mdToast.show(
                          $mdToast
                            .simple()
                            .textContent(data.description)
                            .position('bottom right')
                        );
                        $mdDialog.cancel();
                      });
                  };
                },
              ],
            })
            .then((teacher) => {
              if (teacher) {
                self.getProfiles();
              }
            });
        };
      },
    ],
  })

  .controller('ManagerStudentsCtrl', [
    '$scope',
    '$mdDialog',
    'api',
    '$mdToast',
    function ($scope, $mdDialog, api, $mdToast) {
      console.log('ManagerStudentsCtrl');
    },
  ]);
